'use client';

import { useLocale } from 'next-intl';
import { defaultLocale } from '../i18n/routing';
export function useCurrentLocale() {
  const locale = useLocale();
  return locale ?? defaultLocale;
}